import { HOME_PAGE_DATA } from "data/index";

export const homePagePrepareData = (data: any) => {
  const info = data.prismicHomePage?.data;
  return {
    seo: {
      title: info?.title?.text || undefined,
      description: info?.description?.text || undefined,
      image: info?.image?.url || undefined,
    },
    hero: {
      header: info?.header?.text ?? HOME_PAGE_DATA.hero.header,
      button: {
        desktop: info?.button_text?.text ?? HOME_PAGE_DATA.hero.button.desktop,
        mobile:
          info?.button_text_mobile?.text ?? HOME_PAGE_DATA.hero.button.mobile,
      },
    },
    products: info?.products?.map((product: any) => {
      const { id, data: productInfo } = product?.product?.document;
      return {
        id,
        name: productInfo.name.text,
        description: productInfo.long_description.text,
        links: productInfo.links.map((link: any) => ({
          label: link.label.text,
          href: link.link.url,
        })),
        mainImage: productInfo.preview_image,
        mainLink: {
          label: productInfo.main_link_label.text,
          labelMobile: productInfo.main_link_label.text,
          href: productInfo.main_link.url,
        },
      };
    }),
    partners: info?.partners?.map((partner: any) => ({
      icon: partner?.icon,
      label: partner?.label?.text,
      link: partner?.link?.url,
    })),
    news: info?.news?.map((article: any) => ({
      title: article?.title?.text,
      description: article?.desscription?.text,
      link: article?.link?.url,
      date: article?.date,
    })),
    newsLink: info?.news_link?.url ?? "https://story.madfish.solutions",
  };
};
